<script>
import {EXAMINATION} from '@/utils/data.js'
import question from "@/pages/examination/question.vue";
export default {
  name: "paper",
  computed: {
    question() {
      return question
    }
  },
  data(){
    return {
      loading:false,
      TYPE:EXAMINATION.TYPE,
      TYPE_NAME:EXAMINATION.TYPE_NAME,
      testId:"",
      testName:"",
      time:0,// 单位分
      timeValue:0,// 单位秒
      showTime:'--:--',// 显示单位
      timer:null,
      tip:"认真考试，对自己负责！",
      paperName:"",
      paperScore:0,
      questionList:[],
      progress:0,
    }
  },
  mounted() {
    console.log('this.$router',this.$route)
    this.testId = this.$route.query.id
    console.log('testId',this.testId)
    if(!this.testId){
      this.$message.error("参数错误")
      this.$router.go(-1)
    }else{
      this.getData()
    }
  },
  beforeDestroy() {
    this.closeTime()
  },
  methods:{
    getData(){
      this.$cloud.get('/examination/test/extract',{testId:this.testId}).then(res => {
        console.log('res',res)
        this.testName = res.test.name
        this.time = res.test.time
        this.timeValue = this.time * 60
        this.paperName = res.name
        this.paperScore = res.score
        this.questionList = res.questionList.map(v=>{
          switch (v.type) {
            case EXAMINATION.TYPE.INPUT:
              v['answer'] = ''
              break;
            case EXAMINATION.TYPE.SINGLE:
              v['answer'] = ''
              break;
            case EXAMINATION.TYPE.MULTIPLE:
              v['answer'] = []
              break;
          }
          return v
        })
        this.startTime()
      }).catch(() => {
        this.$router.go(-1)
      }).finally(() => {
        this.loading = false
      })
    },
    simGetData() {
      const list = [
        {
          "id": 39,
          "createdTime": "2024-05-16 10:54:00",
          "updatedTime": "2024-05-16 10:54:00",
          "type": "single",
          "name": "某存储器容量为32K×16位，则（   ）。",
          "score": 4,
          "options": "[{\"name\":\"地址线为32根，数据线为16根\",\"value\":\"A\"},{\"name\":\"地址线为16根，数据线为32根\",\"value\":\"B\"},{\"name\":\"地址线为15根，数据线为16根\",\"value\":\"C\"},{\"name\":\"地址线为16根，数据线为15根\",\"value\":\"D\"}]",
          "answer":"",
          "typeName": "单选题"
        },
        {
          "id": 21,
          "createdTime": "2024-05-16 10:47:40",
          "updatedTime": "2024-05-16 10:47:40",
          "type": "single",
          "name": "运算器的主要功能是进行（   ）。",
          "score": 4,
          "options": "[{\"name\":\"逻辑运算\",\"value\":\"A\"},{\"name\":\"算术运算\",\"value\":\"B\"},{\"name\":\"逻辑运算和算术运算\",\"value\":\"C\"},{\"name\":\"只作加法\",\"value\":\"D\"}]",
          "answer":"",
          "typeName": "单选题"
        },
        {
          "id": 28,
          "createdTime": "2024-05-16 10:50:18",
          "updatedTime": "2024-05-16 10:50:18",
          "type": "single",
          "name": "堆栈寻址的原则是（   ）。",
          "score": 4,
          "options": "[{\"name\":\"随意进出\",\"value\":\"A\"},{\"name\":\"后进先出\",\"value\":\"B\"},{\"name\":\"先进先出\",\"value\":\"C\"},{\"name\":\"后进后出\",\"value\":\"D\"}]",
          "answer":"",
          "typeName": "单选题"
        },
        {
          "id": 37,
          "createdTime": "2024-05-16 10:53:17",
          "updatedTime": "2024-05-16 10:53:17",
          "type": "single",
          "name": "指令流水线需要处理好（   ）3个方面问题。",
          "score": 4,
          "options": "[{\"name\":\"结构相关、数据相关、控制相关\",\"value\":\"A\"},{\"name\":\"结构相关、数据相关、逻辑相关\",\"value\":\"B\"},{\"name\":\"结构相关、逻辑相关、控制相关\",\"value\":\"C\"},{\"name\":\"逻辑相关、数据相关、控制相关\",\"value\":\"D\"}]",
          "answer":"",
          "typeName": "单选题"
        },
        {
          "id": 17,
          "createdTime": "2024-05-16 10:43:05",
          "updatedTime": "2024-05-16 10:43:05",
          "type": "single",
          "name": "浮点数的数值精度取决于（   ）。",
          "score": 4,
          "options": "[{\"name\":\"阶码的位数\",\"value\":\"A\"},{\"name\":\"尾数的位数\",\"value\":\"B\"},{\"name\":\"阶码采用的编码\",\"value\":\"C\"},{\"name\":\"尾数采用的编码\",\"value\":\"D\"}]",
          "answer":"",
          "typeName": "单选题"
        },
        {
          "id": 35,
          "createdTime": "2024-05-16 10:52:37",
          "updatedTime": "2024-05-16 10:52:37",
          "type": "single",
          "name": "硬连线控制器中，使用（   ）提供指令在内存中的地址。",
          "score": 4,
          "options": "[{\"name\":\"节拍发生器\",\"value\":\"A\"},{\"name\":\"程序计数器\",\"value\":\"B\"},{\"name\":\"指令寄存器\",\"value\":\"C\"},{\"name\":\"控制信号形成部件\",\"value\":\"D\"}]",
          "answer":"",
          "typeName": "单选题"
        },
        {
          "id": 22,
          "createdTime": "2024-05-16 10:48:16",
          "updatedTime": "2024-05-16 10:48:16",
          "type": "single",
          "name": "在定点二进制运算器中，加法运算一般通过（   ）来实现。",
          "score": 4,
          "options": "[{\"name\":\"原码运算的二进制加法器\",\"value\":\"A\"},{\"name\":\" 反码运算的二进制加法器\",\"value\":\"B\"},{\"name\":\"原码运算的十进制加法器\",\"value\":\"C\"},{\"name\":\"补码运算的二进制加法器\",\"value\":\"D\"}]",
          "answer":"",
          "typeName": "单选题"
        },
        {
          "id": 41,
          "createdTime": "2024-05-16 10:54:47",
          "updatedTime": "2024-05-16 10:54:47",
          "type": "single",
          "name": "长度相同格式不同的浮点数中，若其他规定均相同，则阶码长、尾数短的浮点数可表示的数值范围大、精度低。",
          "score": 4,
          "options": "[{\"name\":\"√\",\"value\":\"A\"},{\"name\":\"×\",\"value\":\"B\"}]",
          "answer":"",
          "typeName": "单选题"
        },
        {
          "id": 16,
          "createdTime": "2024-05-16 10:42:39",
          "updatedTime": "2024-05-16 11:33:39",
          "type": "single",
          "name": "下列说法正确的是（   ）。",
          "score": 3,
          "options": "[{\"name\":\"采用双符号位补码进行加减运算可以避免溢出\",\"value\":\"A\"},{\"name\":\"只有定点数运算才有可能溢出，浮点数运算不会产生溢出\",\"value\":\"B\"},{\"name\":\"只有将两个正数相加时才有可能产生溢出\",\"value\":\"C\"},{\"name\":\"只有带符号数的运算才有可能产生溢出\",\"value\":\"D\"}]",
          "answer":"",
          "typeName": "单选题"
        },
        {
          "id": 33,
          "createdTime": "2024-05-16 10:51:57",
          "updatedTime": "2024-05-16 10:51:57",
          "type": "single",
          "name": "指令寄存器IR的位数取决于（   ）。",
          "score": 4,
          "options": "[{\"name\":\"存储器的容量\",\"value\":\"A\"},{\"name\":\"指令字长\",\"value\":\"B\"},{\"name\":\"机器字长\",\"value\":\"C\"},{\"name\":\"地址总线宽度\",\"value\":\"D\"}]",
          "answer":"",
          "typeName": "单选题"
        },
        {
          "id": 19,
          "createdTime": "2024-05-16 10:47:00",
          "updatedTime": "2024-05-16 10:47:00",
          "type": "single",
          "name": "关于移码，下列选项中（   ）是错误的。",
          "score": 4,
          "options": "[{\"name\":\"对于同一个数值，移码和补码数值位相同，符号位相反\",\"value\":\"A\"},{\"name\":\"移码的符号位0表示负数，1表示正数\",\"value\":\"B\"},{\"name\":\"移码既可以表示整数，也能表示小数\",\"value\":\"C\"},{\"name\":\" 移码不能用于浮点数的尾数部分\",\"value\":\"D\"}]",
          "answer":"",
          "typeName": "单选题"
        },
        {
          "id": 42,
          "createdTime": "2024-05-16 10:55:03",
          "updatedTime": "2024-05-16 10:55:03",
          "type": "single",
          "name": "浮点数的表示范围取决于尾数的位数，精度取决于阶码的位数。",
          "score": 4,
          "options": "[{\"name\":\"√\",\"value\":\"A\"},{\"name\":\"×\",\"value\":\"B\"}]",
          "answer":"",
          "typeName": "单选题"
        },
        {
          "id": 26,
          "createdTime": "2024-05-16 10:49:43",
          "updatedTime": "2024-05-16 10:49:43",
          "type": "single",
          "name": "输入输出指令的功能是（   ）。",
          "score": 4,
          "options": "[{\"name\":\"进行算术运算和逻辑运算\",\"value\":\"A\"},{\"name\":\"进行主存与CPU之间的数据传送\",\"value\":\"B\"},{\"name\":\"进行CPU和I/O设备之间的数据传送\",\"value\":\"C\"},{\"name\":\"改变程序执行的顺序\",\"value\":\"D\"}]",
          "answer":"",
          "typeName": "单选题"
        },
        {
          "id": 38,
          "createdTime": "2024-05-16 10:53:38",
          "updatedTime": "2024-05-16 10:53:38",
          "type": "single",
          "name": "若主存每个存储单元存8位数据，则（   ）。",
          "score": 4,
          "options": "[{\"name\":\"其地址线也为8位\",\"value\":\"A\"},{\"name\":\"其地址线为16位\",\"value\":\"B\"},{\"name\":\"其地址线与8有关\",\"value\":\"C\"},{\"name\":\"其地址线与8无关\",\"value\":\"D\"}]",
          "answer":"",
          "typeName": "单选题"
        },
        {
          "id": 24,
          "createdTime": "2024-05-16 10:48:59",
          "updatedTime": "2024-05-16 10:48:59",
          "type": "single",
          "name": "运算器由多个部件组成，其核心部分是（   ）。",
          "score": 4,
          "options": "[{\"name\":\"多路开关\",\"value\":\"A\"},{\"name\":\"数据总线\",\"value\":\"B\"},{\"name\":\"累加寄存器\",\"value\":\"C\"},{\"name\":\"算逻运算单元\",\"value\":\"D\"}]",
          "answer":"",
          "typeName": "单选题"
        },
        {
          "id": 43,
          "createdTime": "2024-05-16 10:56:55",
          "updatedTime": "2024-05-16 10:57:30",
          "type": "multiple",
          "name": " 对于阶码和尾数都用补码表示的浮点数，判断运算结果是否为规格化，错误的方法是_____。",
          "score": 10,
          "options": "[{\"name\":\"阶符和数符相同\",\"value\":\"A\"},{\"name\":\"阶符和数符相异\",\"value\":\"B\"},{\"name\":\"数符与尾数小数点后第一位数字相同\",\"value\":\"C\"},{\"name\":\"数符与尾数小数点后第一位数字相异\",\"value\":\"D\"}]",
          "answer":"",
          "typeName": "多选题"
        },
        {
          "id": 34,
          "createdTime": "2024-05-16 10:52:16",
          "updatedTime": "2024-05-16 10:52:16",
          "type": "single",
          "name": "指令周期是CPU（   ）的时间。",
          "score": 4,
          "options": "[{\"name\":\"执行一条指令\",\"value\":\"A\"},{\"name\":\"从主存中读取一条指令\",\"value\":\"B\"},{\"name\":\" 分析一条指令\",\"value\":\"C\"},{\"name\":\"从主存中读取一条指令并分析、执行这条指令\",\"value\":\"D\"}]",
          "answer":"",
          "typeName": "单选题"
        },
        {
          "id": 18,
          "createdTime": "2024-05-16 10:44:32",
          "updatedTime": "2024-05-16 10:44:32",
          "type": "single",
          "name": "长度相同但格式不同的2种浮点数，假设前者阶码长、尾数短，后者阶码短、尾数长，其他规定均相同，则下列选项中（   ）是正确的。",
          "score": 4,
          "options": "[{\"name\":\"两者可表示的数的范围和精度相同\",\"value\":\"A\"},{\"name\":\"前者可表示的数的范围大且精度高\",\"value\":\"B\"},{\"name\":\"后者可表示的数的范围小但精度高\",\"value\":\"C\"},{\"name\":\"前者可表示的数的范围小且精度高\",\"value\":\"D\"}]",
          "answer":"",
          "typeName": "单选题"
        },
        {
          "id": 29,
          "createdTime": "2024-05-16 10:50:39",
          "updatedTime": "2024-05-16 10:50:39",
          "type": "single",
          "name": "变址寻址方式中，操作数的有效地址等于（   ）的内容加上变址偏移量。",
          "score": 4,
          "options": "[{\"name\":\"基址寄存器\",\"value\":\"A\"},{\"name\":\"堆栈指示器\",\"value\":\"B\"},{\"name\":\"变址寄存器\",\"value\":\"C\"},{\"name\":\"程序计数器\",\"value\":\"D\"}]",
          "answer":"",
          "typeName": "单选题"
        },
        {
          "id": 23,
          "createdTime": "2024-05-16 10:48:38",
          "updatedTime": "2024-05-16 10:48:38",
          "type": "single",
          "name": "ALU完成运算后要输出运算结果，但下列选项（   ）不是运算器给出的结果特征信息。",
          "score": 4,
          "options": "[{\"name\":\"是否溢出\",\"value\":\"A\"},{\"name\":\"有无进位\",\"value\":\"B\"},{\"name\":\"结果是否为零\",\"value\":\"C\"},{\"name\":\"时钟信号\",\"value\":\"D\"}]",
          "answer":"",
          "typeName": "单选题"
        }
      ]
      this.loading = true
      setTimeout(() => {
        this.testName = "2月月考"
        this.time = 1
        this.timeValue = this.time * 60
        this.paperName = '2月月考试卷A'
        this.paperScore = 100
        this.questionList = list.map(v=>{
          switch (v.type) {
            case EXAMINATION.TYPE.SINGLE:
              v['answer'] = ''
              break
            case EXAMINATION.TYPE.MULTIPLE:
              v['answer'] = []
              break
            case EXAMINATION.TYPE.INPUT:
              v['answer'] = ''
              break
          }
          return v
        })
        this.loading = false
        this.startTime()
      },100)
    },
    startTime(){
      this.timeDo()
      this.timer = setInterval(() => {
        this.timeDo()
      },1000)
    },
    timeDo(){
      if(this.timeValue < 1){
        this.closeTime()
        this.doSubmit().then(() => {
          console.log("试卷已自动提交")
        })
        this.$alert('考试时间已到，结束考试！', '考试结束', {
          confirmButtonText: '确定',
          callback: () => {
            this.$cloud.go('/pages/web/examination')
          }
        });
      }
      let min = parseInt(this.timeValue / 60) + ''
      let sec = (this.timeValue%60) + ''
      this.showTime = min.padStart(2,'0') + ':' + sec.padStart(2,'0')
      this.timeValue--
    },
    closeTime(){
      if(this.timer){
        clearInterval(this.timer)
      }
    },
    createOptions(options){
      let list = []
      try {
        list = JSON.parse(options)
      }catch (e) {
        console.log('转换失败',e)
      }
      return list
    },
    calculateProgress(){
      let count = 0
      setTimeout(() => {
        this.questionList.forEach(x=>{
          if(this.checkAnswer(x)){
            count++
          }
        })
        this.progress = parseInt(count/this.questionList.length * 100)
        console.log("进度计算",this.progress,count)
      },6)
    },
    checkAnswer(x){
      let r = false
      if(x.type === EXAMINATION.TYPE.MULTIPLE ){
        if(x.answer && x.answer.length > 0){
          r = true
        }
      }else if(x.answer){
        r = true
      }
      return r
    },
    handleSubmit(){
      this.$confirm('确认已完成作答并提交?', '提示', {
        confirmButtonText: '提交',
        cancelButtonText: '我在看看',
        type: 'warning',
        beforeClose:(action, instance, done) => {
          console.log('action, done',action, done)
          console.log('instance',instance)
          if(action === 'confirm'){
            instance.confirmButtonLoading = true
            this.doSubmit().then(() => {
              this.$message({
                type: 'success',
                message: '交卷成功'
              });
              this.$router.replace('/pages/web/examination')
              done()
            }).finally(() => {
              instance.confirmButtonLoading = false
            })
          }else{
            done()
          }
        }
      }).then(() => {
      }).catch(() => {
        console.log('我在看看')
      });
    },
    doSubmit(){
      return new Promise((resolve, reject) => {
        let answerList = this.questionList.map(v=>{
          return {
            questionId:v.id,
            answer:v.answer?v.answer:''
          }
        })
        console.log("提交",this.questionList,answerList)
        this.$cloud.post('examination/test/submit',{testId:this.testId,answerList:answerList}).then(() => {
          resolve()
        }).catch(() =>{
          reject()
        })
      })
    }

  }
}
</script>

<template>
  <div class="main-body flex " v-loading="loading">
    <div class="paper  flex-1 bg-white shadow-lg  rounded-xl mr-8 h-full overflow-y-auto" >
      <el-scrollbar class="h-full">
      <div class="title mb-4">
        <div class="test-name">
          {{testName}}
        </div>
        <div class="paper-name">
          {{paperName}}
        </div>
        <div class="paper-name">
          满分：{{paperScore}}
        </div>
      </div>
      <div class="paper-body pl-6 pr-6 " @mouseup="calculateProgress">
        <el-scrollbar class="h-full">
        <div class="paper-question  mb-4" v-for="(question,index) in questionList">
          <div class="question-title">
            {{index+1}}、({{TYPE_NAME[question.type]}}) {{question.name}}
          </div>
          <div v-if="question.type === TYPE.SINGLE">
            <el-radio-group v-model="question.answer">
              <el-radio class="block mt-2 mb-2" v-for="option in createOptions(question.options)" :label="option.value">{{option.value}} 、 {{ option.name }}</el-radio>
            </el-radio-group>
          </div>
          <div v-if="question.type === TYPE.MULTIPLE">
            <el-checkbox-group v-model="question.answer">
              <el-checkbox class="block mt-2 mb-2" v-for="option in createOptions(question.options)" :label="option.value">{{option.value}} 、 {{ option.name }}</el-checkbox>
            </el-checkbox-group>
          </div>
          <div class="h-20" v-if="question.type === TYPE.INPUT">
            <el-input  v-model="question.answer"/>
          </div>
        </div>
        </el-scrollbar>
      </div>
      </el-scrollbar>
    </div>
    <div class="status w-80 h-full flex flex-col bg-white shadow-lg  rounded-xl">
      <div class="h-20 pl-28 font-bold text-4xl leading-10 pt-8">
        {{showTime}}
      </div>
      <div class="text-center h-12 pt-2">
        <el-progress class="m-2" :percentage="progress"/>
      </div>
      <div class="question-answer-list overflow-y-auto grid grid-cols-6 m-4">
        <div class="question-answer bg-red-100 w-10 h-10 text-center leading-10 select-none rounded transition-all hover:bg-red-200" :class="{'bg-red-400':checkAnswer(item)}" v-for="(item,index) in questionList">
          {{index + 1}}
        </div>
      </div>
      <div class="h-10 m-4">
        <el-button class="w-full" type="primary" @click="handleSubmit">
          交卷
        </el-button>
      </div>
    </div>
  </div>
</template>

<style scoped>
.main-body{
  height: calc(100vh - 150px);
}
.test-name{
  text-align: center;
  font-size: 28px;
  margin-top: 20px;
  margin-bottom: 6px;
}
.paper-name{
  text-align: center;
  font-size: 14px;
  color:#777;
}
.question-answer-list{
  grid-auto-flow: row;
  grid-row-gap: 14px;
  align-content: start;
}
</style>
